import React from 'react';
import { Redirect } from '../../../Router';
import { recruitmentRoutes } from './routes';

export const RedirectToRecruitmentHome: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return <Redirect to={recruitmentRoutes.jobsList.route} />;
};

export default RedirectToRecruitmentHome;
